document.addEventListener('DOMContentLoaded', () => {
    const thumbsSwiper = new Swiper(".ingredients-swatches-list", {
        spaceBetween: 10,
        autoHeight: true,
        slidesPerView: 'auto',
        breakpoints: {
            0: {
              direction: "horizontal",
              freeMode: true,
            },
            990: {
              direction: "vertical",
            }
        },
        on: {
            slideChange: onSlideChanged
        }
    });

    new Swiper(".ingredients-list", {
        spaceBetween: 10,
        effect: "fade",
        fadeEffect: {
            crossFade: true
        },
        thumbs: {
          swiper: thumbsSwiper,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        on: {
            slideChange: onSlideChanged
        }
    });
});

function onSlideChanged() {
    const selectedSlideIndex = this.activeIndex;
    const allSlides = this.wrapperEl;
    const selectedSlide = allSlides.querySelectorAll(".swiper-slide")[selectedSlideIndex];

    if (selectedSlide) {
        const slideBackgroundImage = selectedSlide.getAttribute("data-background-image");

        if (slideBackgroundImage) {
            const ingredientsParentContainer = selectedSlide.closest(".ingredients");
            const currentBackgroundImage = ingredientsParentContainer?.querySelector(".ingredient-background-image");

            currentBackgroundImage.src = slideBackgroundImage;
        }
    }
}
